import { type ReactNode } from "react";

interface StepCardProps {
  step: number;
  title: string;
  description?: string;
  icon?: ReactNode;
  action?: ReactNode;
}

function StepCard({ step, title, description, icon, action }: StepCardProps) {
  return (
    <div className="flex gap-3">
      <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand-500 text-sm font-bold text-white">
        {step}
      </div>
      <div className="flex-1 space-y-2">
        <div className="flex items-center gap-2">
          {icon}
          <h4 className="font-medium text-text-primary">{title}</h4>
        </div>
        {description && <p className="text-sm text-text-secondary">{description}</p>}
        {action && <div className="pt-1">{action}</div>}
      </div>
    </div>
  );
}

export { StepCard };
